import { Program } from '@/store/program/types';
import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';

export type ProgramResponse = {
	program: Program | null;
};

export async function getProgram(
	programId: string | string[] | undefined,
	userData: RequestUserData,
): Promise<Program | null> {
	const id = Array.isArray(programId) ? programId[0] : programId;
	try {
		if (!id) return null;
		const result = await apiRequest<ProgramResponse>({
			endpoint: `content/programs/${id}`,
			method: 'GET',
			userData,
			customHeaders: {
				'x-device-capabilities': 'v1;signedCookie;streamOnly',
			},
		});
		return result?.data?.program || null;
	} catch (err) {
		return null;
	}
}
